import { render } from "./clock.vue?vue&type=template&id=05394164"
import script from "./clock.vue?vue&type=script&setup=true&lang=js"
export * from "./clock.vue?vue&type=script&setup=true&lang=js"

import "./clock.vue?vue&type=style&index=0&id=05394164&lang=scss"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.5.17_webpack@5.97.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"packages/ui-components/src/components/icons/clock/clock.vue"]])

export default __exports__